import React, {useEffect, useState} from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";

import WithUserData from "../../WithUserData";
import { useMutation } from "@apollo/client";
import styles from "../../../TalentApplication/styles.module.css";
import Images from "../../../Admin/Model/Images";
import { GET_USER_IMAGES } from "../../WithUserData/queries";
import Spinner from "../../../../assets/Spinner/Spinner";
import {Link} from "react-router-dom";


const UserImages = ({user}) => {
    const [ getUserImages ] = useMutation(GET_USER_IMAGES)
    const [ userImages, setUserImages ] = useState([])
    const [ loading, setLoading ] = useState(true)
    const fetchUserImages = async () => {
        try {
            const resp =  await getUserImages();
            if(resp.data.getUserImages) {
                setUserImages(resp.data.getUserImages);
                setLoading(false);
            }
        } catch (e) {
            setLoading(false)
            console.log(e)
        }
    }
    useEffect(() => {
        //Remove any previously set instagram access token
        localStorage.removeItem('instagram_access_token');
        fetchUserImages()
    }, []);
    return (
        <>
            {loading &&
                <div className={`w-full h-full ${styles.Loading}`}>
                    <Spinner color='black' />
                </div>
            }
            {!loading && <div className='w-full h-full flex flex-col px-2'>
                <div className="w-full h-16 flex justify-between items-center mt-6">
                    <Link
                        to="/account/edit-profile"
                        className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                    >
                        <div className="w-10 flex items-center justify-center">
                            <MdOutlineArrowBackIos size={18}/>
                        </div>
                        <span>Back</span>
                    </Link>
                    <div className="text-black text-2xl font-bold mr-10">Images</div>
                </div>
                <>
                    <Link
                        to={user.instagramToken ? "/account/instagram/select-photos" : "/account/instagram/connect"}
                        className="text-center text-black underline mb-4 mt-2 mx-auto"
                    >
                        Select New Photos
                    </Link>
                    {!!userImages?.length && <div className='w-full pb-10'>
                        <Images images={userImages} visibleSlides={3} theme='white'/>
                    </div>}
                    {!userImages?.length && <p className="py-6 text-center">
                        Your selected photos will appear here once added.
                    </p>}
                </>
            </div>}
        </>
    )
}

const Media = () => {
    return (
        <WithUserData>
            {({user}) => <UserImages user={user}/>}
        </WithUserData>
    );
};

export default Media;